import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { faGlobe, faBuilding, faShoppingCart, faRobot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PrimaryButton } from '../common/Buttons';
import './style.css';

const services = [
  { icon: faGlobe, label: 'Landing Pages' },
  { icon: faBuilding, label: 'Corporate Sites' },
  { icon: faShoppingCart, label: 'E-Commerce' },
  { icon: faRobot, label: 'AI & Automation Integrations' },
];

function NoWebsiteSection({ id }) {
  return (
    <section className="no-website-section" id={id || "web-development"}>
      <Container>
        <Row className="justify-content-center text-center mb-4">
          <Col md="8">
            <h2 className="no-website-title">
              Don’t have a website yet?
            </h2>
            <div className="no-website-subtitle">
              No worries — we can build it for you. Website development is quoted separately and starts at just $399.
            </div>
          </Col>
        </Row>

        <Row className="text-center mb-4">
          {services.map((item, index) => (
            <Col key={index} xs="6" md="3" className="mb-4">
              <div className="no-website-service">
                <FontAwesomeIcon
                  icon={item.icon}
                  size="2x"
                  className="no-website-service-icon"
                />
                <div className="no-website-service-label">
                  {item.label}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="justify-content-center">
          <Col md="auto">
            <PrimaryButton href="web-development">
              🧱 View Web Development Services
            </PrimaryButton>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NoWebsiteSection;
